import {
    GET_USERS_REQUEST,
    GET_USERS_RESPONSE,
    GET_USERS_RESPONSE_ERROR,
    SWITCH_TYPE_OF_USER,
    GET_REGIONS_RESPONSE_ERROR,
    GET_REGIONS_RESPONSE,
    GET_REGIONS_REQUEST,
    GET_STATES_RESPONSE_ERROR,
    GET_STATES_RESPONSE,
    GET_STATES_REQUEST,
    GET_PROVIDERS_REQUEST,
    GET_PROVIDERS_RESPONSE,
    GET_PROVIDERS_RESPONSE_ERROR,
    SET_PROVIDER_SELECTED,
    SET_ADMIN_SELECTED,
    ADD_PROVIDER_RESPONSE,
    ADD_PROVIDER_REQUEST,
    ADD_PROVIDER_RESPONSE_ERROR,
    ADD_ADMIN_RESPONSE,
    ADD_ADMIN_REQUEST,
    ADD_ADMIN_RESPONSE_ERROR,
    PUT_PROVIDER_RESPONSE,
    PUT_PROVIDER_REQUEST,
    PUT_PROVIDER_RESPONSE_ERROR,
    DELETE_PROVIDER_REQUEST,
    DELETE_PROVIDER_RESPONSE,
    DELETE_PROVIDER_RESPONSE_ERROR,
    GET_BRANCHES_REQUEST,
    GET_BRANCHES_RESPONSE,
    GET_BRANCHES_RESPONSE_ERROR,
    SET_NAME,
    GET_PROVIDERS_ME_REQUEST,
    GET_PROVIDERS_ME_RESPONSE,
    GET_PROVIDERS_ME_RESPONSE_ERROR,
    CLEAN_EDIT_USER_STATE,
    CLEAN_NEW_PROVIDER_STATE,
    CLEAN_NEW_ADMIN_STATE,
    SET_LIST_CONFIG,
    GET_AFFILIATE_REQUEST,
    GET_AFFILIATE_RESPONSE,
    GET_AFFILIATE_RESPONSE_ERROR,
    CLEAN_AFFILIATES,
    CLEAN_USERS,
    CLEAN_GET_BRANCHES_STATE,
    GET_PLANS_REQUEST,
    GET_PLANS_RESPONSE,
    GET_PLANS_RESPONSE_ERROR,
    GET_MEDICAL_SERVICES_REQUEST,
    GET_MEDICAL_SERVICES_RESPONSE,
    GET_MEDICAL_SERVICES_RESPONSE_ERROR,
    GET_ALL_MEDICAL_SERVICES_REQUEST,
    GET_ALL_MEDICAL_SERVICES_RESPONSE,
    GET_ALL_MEDICAL_SERVICES_RESPONSE_ERROR,
    APPROVE_ATTENTION_REQUEST,
    APPROVE_ATTENTION_RESPONSE,
    APPROVE_ATTENTION_RESPONSE_ERROR,
    CREATE_ATTENTION_REQUEST,
    CREATE_ATTENTION_RESPONSE,
    CREATE_ATTENTION_RESPONSE_ERROR,
    CLEAN_CREATE_ATTENTION_STATE,
    SEND_QUOTE_EMAIL_REQUEST,
    SEND_QUOTE_EMAIL_RESPONSE,
    SEND_QUOTE_EMAIL_RESPONSE_ERROR,
    CLEAN_SEND_QUOTE_EMAIL_STATE,
    CLEAN_APPROVE_ATTENTION_STATE,
    CLEAN_ATTENTION,
    SET_AFFILIATE_SELECTED,
    SET_ATTENTION_FOR_CREATE,
    GET_BRANCHES_PROVIDERS_REQUEST,
    GET_BRANCHES_PROVIDERS_RESPONSE,
    GET_BRANCHES_PROVIDERS_RESPONSE_ERROR,
    CLEAN_BRANCHES,
    CLEAN_PROVIDERS_BRANCHES,
    GET_ALL_ATTENTIONS_REQUEST,
    GET_ALL_ATTENTIONS_RESPONSE,
    GET_ALL_ATTENTIONS_RESPONSE_ERROR,
    SELECT_SELF_RESPONSE,
    SELECT_SELF,
    SELECT_SELF_RESPONSE_ERROR,
    CLEAN_SELECT_SELF,
    DELETE_ADMIN_REQUEST,
    DELETE_ADMIN_RESPONSE,
    DELETE_ADMIN_RESPONSE_ERROR,
    SELECT_PLAN,
    CLEAN_GET_AFFILIATES_STATE,
    CLEAN_LIST_CONFIG,
    SET_ATTENTIONS_SELECTED,
    CLEAN_ATTENTIONS_SELECTED,
    BULK_INSERT, BULK_INSERT_RESPONSE,
    BULK_INSERT_RESPONSE_ERROR,
    CLEAN_BULK_INSERT,
    GET_ALL_ATTENTIONS_DOWNLOAD_REQUEST,
    GET_ALL_ATTENTIONS_DOWNLOAD_RESPONSE,
    GET_AMOUNT_LIST_RESPONSE,
    GET_AMOUNT_LIST_REQUEST,
    GET_AMOUNT_LIST_RESPONSE_ERROR, GET_ALL_AMOUNTS_DOWNLOAD_RESPONSE,
    CLEAN_AMOUNT_LIST_STATE, CLEAN_ATTENTION_FOR_CREATE,
    SET_BRANCH_AND_PROVIDER, DELETE_ATTENTION_RESPONSE, DELETE_ATTENTION_RESPONSE_ERROR, CLEAR_DELETE_ATTENTION_STATE,
    PUT_CHANGE_PASSWORD_RESPONSE,
    PUT_CHANGE_PASSWORD_RESPONSE_ERROR, RESET_CHANGE_PASSWORD_STATE,
// [MODULE REDUCER] IMPORT ACTIONS
} from './home.actions';
import {REHYDRATE} from 'redux-persist';

const initialState = {
    name: undefined,
    users: [],
    columnData: {
        lender: 'NOMBRE',
        code: 'CUIT/CUIL',
        data1: 'TELÉFONO',
        data2: 'EMAIL',
        venue: 'PRESTADOR',
        branch: 'SEDE',
    },
    columnDataAdmin: {email: 'EMAIL', firstName: 'NOMBRE', lastName: 'APELLIDO'},
    columnDataPlans: [{title: 'NOMBRE', att: 'name'}],
    title: 'Inicio',
    states: [],
    regions: [],
    branches: [],
    branchesProviders: [],
    providers: [],
    providerSelected: undefined,
    branchAndProviderForAttention: undefined,
    adminSelected: undefined,
    editProviderState: {
        loading: false,
        success: false,
        error: false,
    },
    newProviderState: {
        loading: false,
        success: false,
        error: false,
    },
    newAdminState: {
        loading: false,
        success: false,
        error: false,
    },
    getProvidersState: {
        loading: false,
        success: false,
        error: false,
    },
    getUsersState: {
        loading: false,
        success: false,
        error: false,
    },
    providerListConfig: {
        page: 1,
        size: 100, // TODO: this is hardcoded
        orderBy: [],
        searchTags: {},
    },
    adminListConfig: {
        page: 1,
        size: 100,
        orderBy: 'email',
        search: '',
    },
    amountListConfig: {
        page: 1,
        providerName: '',
    },
    affiliates: [],
    getAffiliatesState: {
        loading: false,
        success: false,
        error: false,
    },
    getBranchesState: {
        loading: false,
        success: false,
        error: false,
    },
    getBranchesProvidersState: {
        loading: false,
        success: false,
        error: false,
    },
    plans: [],
    getPlansState: {
        loading: false,
        success: false,
        error: false,
    },
    medicalServices: [],
    getMedicalServicesState: {
        loading: false,
        success: false,
        error: false,
    },
    allMedicalServices: [],
    getAllMedicalServicesState: {
        loading: false,
        success: false,
        error: false,
    },
    attention: undefined,
    approveAttentionState: {
        loading: false,
        success: false,
        error: false,
        message: '',
    },
    createAttentionState: {
        loading: false,
        success: false,
        error: false,
    },
    sendQuoteEmailState: {
        loading: false,
        success: false,
        error: false,
    },
    affiliateSelected: undefined,
    attentionForCreate: undefined,
    flagAmount: false,
    allAttentions: [],
    attentionsToDownload: [],
    getAllAttentionsToDownloadState: {
        loading: false,
        success: false,
        error: false,
    },
    getAllAttentionsState: {
        loading: false,
        success: false,
        error: false,
    },
    deletedAttentionState: {
        loading: false,
        success: false,
        error: false,
    },
    setSelfState: {
        loading: false,
        success: false,
        error: false,
        featureFlag: false,
    },
    attentionsListConfig: {
        page: 1,
        size: 10,
        orderBy: [],
        searchTags: {},
    },
    medicalServicesListConfig: {
        page: 1,
        size: 10,
        orderBy: [],
        searchTags: {},
    },
    allMedicalServicesConfig: {
        page: 1,
        size: 10,
        orderBy: [],
        searchTags: {},
    },
    planSelected: undefined,
    attentionsSelected: [],
    bulkInsertState: {
        loading: false,
        success: false,
        error: false,
    },
    bulkInsertResponse: undefined,
    amountList: [],
    amountListToDownload: [],
    getAmountListState: {
        loading: false,
        success: false,
        error: false,
    },
    getAmountListToDownloadState: {
        loading: false,
        success: false,
        error: false,
    },
    putChangePasswordState: {
        loading: false,
        success: false,
        error: false,
    },
};

const homeReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USERS_REQUEST:
        case GET_USERS_RESPONSE:
        case GET_USERS_RESPONSE_ERROR:
            return {
                ...state,
                users: action.type === GET_USERS_RESPONSE ? action.response : state.users,
                getUsersState: {
                    loading: action.type === GET_USERS_REQUEST,
                    success: action.type === GET_USERS_RESPONSE,
                    error: action.type === GET_USERS_RESPONSE_ERROR && action.error,
                },
            };
        case SWITCH_TYPE_OF_USER:
            return {...state, title: action.name};
        case GET_STATES_REQUEST:
        case GET_STATES_RESPONSE:
        case GET_STATES_RESPONSE_ERROR:
            return {
                ...state,
                states: action.type === GET_STATES_RESPONSE ? action.response : state.states,
            };
        case GET_REGIONS_REQUEST:
        case GET_REGIONS_RESPONSE:
        case GET_REGIONS_RESPONSE_ERROR:
            return {
                ...state,
                regions: action.type === GET_REGIONS_RESPONSE ? action.response : state.regions,
            };
        case PUT_CHANGE_PASSWORD_RESPONSE:
            return {
                ...state,
                putChangePasswordState: {
                    loading: false,
                    success: true,
                    error: false,
                },
            };
        case PUT_CHANGE_PASSWORD_RESPONSE_ERROR:
            return {
                ...state,
                putChangePasswordState: {
                    loading: false,
                    success: false,
                    error: true,
                },
            };
        case RESET_CHANGE_PASSWORD_STATE:
            return {
                ...state,
                putChangePasswordState: initialState.putChangePasswordState,
            };
        case GET_BRANCHES_REQUEST:
        case GET_BRANCHES_RESPONSE:
        case GET_BRANCHES_RESPONSE_ERROR:
            return {
                ...state,
                branches: action.type === GET_BRANCHES_RESPONSE ? action.response.result : state.branches,
                getBranchesState: {
                    loading: action.type === GET_BRANCHES_REQUEST,
                    success: action.type === GET_BRANCHES_RESPONSE,
                    error: action.type === GET_BRANCHES_RESPONSE_ERROR && action.error,
                },
            };
        case GET_BRANCHES_PROVIDERS_REQUEST:
        case GET_BRANCHES_PROVIDERS_RESPONSE:
        case GET_BRANCHES_PROVIDERS_RESPONSE_ERROR:
            return {
                ...state,
                branchesProviders: action.type === GET_BRANCHES_PROVIDERS_RESPONSE ? action.response.result : state.branchesProviders,
                getBranchesProvidersState: {
                    loading: action.type === GET_BRANCHES_PROVIDERS_REQUEST,
                    success: action.type === GET_BRANCHES_PROVIDERS_RESPONSE,
                    error: action.type === GET_BRANCHES_PROVIDERS_RESPONSE_ERROR && action.error,
                },
            };
        case GET_PROVIDERS_REQUEST:
        case GET_PROVIDERS_RESPONSE:
        case GET_PROVIDERS_RESPONSE_ERROR:
            return {
                ...state,
                providers: action.type === GET_PROVIDERS_RESPONSE ? action.response : state.providers,
                getProvidersState: {
                    loading: action.type === GET_PROVIDERS_REQUEST,
                    success: action.type === GET_PROVIDERS_RESPONSE,
                    error: action.type === GET_PROVIDERS_RESPONSE_ERROR && action.error,
                },
            };
        case GET_PROVIDERS_ME_REQUEST:
        case GET_PROVIDERS_ME_RESPONSE:
        case GET_PROVIDERS_ME_RESPONSE_ERROR:
            return {
                ...state,
                providers: action.type === GET_PROVIDERS_ME_RESPONSE ? action.response : state.providers,
                getProvidersState: {
                    loading: action.type === GET_PROVIDERS_ME_REQUEST,
                    success: action.type === GET_PROVIDERS_ME_RESPONSE,
                    error: action.type === GET_PROVIDERS_ME_RESPONSE_ERROR && action.error,
                },
            };
        case ADD_PROVIDER_REQUEST:
        case ADD_PROVIDER_RESPONSE:
        case ADD_PROVIDER_RESPONSE_ERROR:
            return {
                ...state,
                providerSelected: action.type === ADD_PROVIDER_RESPONSE ? action.response : state.providerSelected,
                newProviderState: {
                    loading: action.type === ADD_PROVIDER_REQUEST,
                    success: action.type === ADD_PROVIDER_RESPONSE,
                    error: action.type === ADD_PROVIDER_RESPONSE_ERROR && action.error,
                },
            };
        case SET_PROVIDER_SELECTED:
            return {
                ...state,
                providerSelected: action.providerSelected?.response || action.providerSelected,
            };
        case SET_ADMIN_SELECTED:
            return {
                ...state,
                adminSelected: action.adminSelected,
            };
        case ADD_ADMIN_REQUEST:
        case ADD_ADMIN_RESPONSE:
        case ADD_ADMIN_RESPONSE_ERROR:
            return {
                ...state,
                providerSelected: action.type === ADD_ADMIN_RESPONSE ? action.response : state.providerSelected,
                newAdminState: {
                    loading: action.type === ADD_ADMIN_REQUEST,
                    success: action.type === ADD_ADMIN_RESPONSE,
                    error: action.type === ADD_ADMIN_RESPONSE_ERROR && action.error,
                },
            };
        case PUT_PROVIDER_REQUEST:
        case PUT_PROVIDER_RESPONSE:
        case PUT_PROVIDER_RESPONSE_ERROR:
            return {
                ...state,
                editProviderState: {
                    loading: action.type === PUT_PROVIDER_REQUEST,
                    success: action.type === PUT_PROVIDER_RESPONSE,
                    error: action.type === PUT_PROVIDER_RESPONSE_ERROR && action.error,
                },
            };
        // [MODULE REDUCER] SWITCH CASE
        case DELETE_PROVIDER_REQUEST:
        case DELETE_PROVIDER_RESPONSE:
        case DELETE_PROVIDER_RESPONSE_ERROR:
        case DELETE_ADMIN_REQUEST:
        case DELETE_ADMIN_RESPONSE:
        case DELETE_ADMIN_RESPONSE_ERROR:
            return {...state};
        case SET_NAME:
            return {
                ...state,
                name: action.name,
            };
        case CLEAN_EDIT_USER_STATE:
            return {
                ...state,
                editProviderState: initialState.editProviderState,
            };
        case CLEAN_NEW_PROVIDER_STATE:
            return {
                ...state,
                newProviderState: initialState.newProviderState,
            };
        case CLEAN_NEW_ADMIN_STATE:
            return {
                ...state,
                newAdminState: initialState.newAdminState,
            };
        case CLEAN_GET_BRANCHES_STATE:
            return {
                ...state,
                getBranchesState: initialState.getBranchesState,
            };
        case CLEAN_CREATE_ATTENTION_STATE:
            return {
                ...state,
                createAttentionState: initialState.createAttentionState,
            };
        case CLEAN_SEND_QUOTE_EMAIL_STATE:
            return {
                ...state,
                sendQuoteEmailState: initialState.sendQuoteEmailState,
            };
        case SEND_QUOTE_EMAIL_REQUEST:
        case SEND_QUOTE_EMAIL_RESPONSE:
        case SEND_QUOTE_EMAIL_RESPONSE_ERROR:
            return {
                ...state,
                sendQuoteEmailState: {
                    loading: action.type === SEND_QUOTE_EMAIL_REQUEST,
                    success: action.type === SEND_QUOTE_EMAIL_RESPONSE,
                    error: action.type === SEND_QUOTE_EMAIL_RESPONSE_ERROR && action.error,
                },
            };
        case CLEAN_APPROVE_ATTENTION_STATE:
            return {
                ...state,
                flagAmount: initialState.flagAmount,
                approveAttentionState: initialState.approveAttentionState,
            };
        case CLEAN_BRANCHES:
            return {
                ...state,
                branches: initialState.branches,
                getBranchesProvidersState: initialState.getBranchesProvidersState,
            };
        case CLEAN_PROVIDERS_BRANCHES:
            return {
                ...state,
                branchesProviders: initialState.branchesProviders,
                getBranchesProvidersState: initialState.getBranchesProvidersState,
            };
        case SET_LIST_CONFIG:
            const list = action.body.list;
            const config = action.body.config;
            if (list !== 'providerListConfig' &&
                list !== 'adminListConfig' &&
                list !== 'attentionsListConfig' &&
                list !== 'allMedicalServicesConfig' &&
                list !== 'amountListConfig' &&
                list !== 'medicalServicesListConfig') return state;

            return {
                ...state,
                [list]: {...state[list], ...config},
            };
        case CLEAN_LIST_CONFIG:
            if (action.list !== 'providerListConfig' &&
                action.list !== 'adminListConfig' &&
                action.list !== 'amountListConfig' &&
                action.list !== 'attentionsListConfig' &&
                action.list !== 'allMedicalServicesConfig' &&
                action.list !== 'medicalServicesListConfig') return state;

            return {
                ...state,
                [action.list]: {...initialState[action.list]},
            };
        case GET_AFFILIATE_REQUEST:
        case GET_AFFILIATE_RESPONSE:
        case GET_AFFILIATE_RESPONSE_ERROR:
            return {
                ...state,
                affiliates: action.type === GET_AFFILIATE_RESPONSE ? action.response.affiliates : state.affiliates,
                getAffiliatesState: {
                    loading: action.type === GET_AFFILIATE_REQUEST,
                    success: action.type === GET_AFFILIATE_RESPONSE,
                    error: action.type === GET_AFFILIATE_RESPONSE_ERROR && action.error,
                },
            };
        case GET_PLANS_REQUEST:
        case GET_PLANS_RESPONSE:
        case GET_PLANS_RESPONSE_ERROR:
            return {
                ...state,
                plans: action.type === GET_PLANS_RESPONSE ? action.response : state.plans,
                getPlansState: {
                    loading: action.type === GET_PLANS_REQUEST,
                    success: action.type === GET_PLANS_RESPONSE,
                    error: action.type === GET_PLANS_RESPONSE_ERROR && action.error,
                },
            };
        case GET_MEDICAL_SERVICES_REQUEST:
        case GET_MEDICAL_SERVICES_RESPONSE:
        case GET_MEDICAL_SERVICES_RESPONSE_ERROR:
            return {
                ...state,
                medicalServices: action.type === GET_MEDICAL_SERVICES_RESPONSE ? action.response : state.medicalServices,
                getMedicalServicesState: {
                    loading: action.type === GET_MEDICAL_SERVICES_REQUEST,
                    success: action.type === GET_MEDICAL_SERVICES_RESPONSE,
                    error: action.type === GET_MEDICAL_SERVICES_RESPONSE_ERROR && action.error,
                },
            };
        case GET_ALL_MEDICAL_SERVICES_REQUEST:
        case GET_ALL_MEDICAL_SERVICES_RESPONSE:
        case GET_ALL_MEDICAL_SERVICES_RESPONSE_ERROR:
            return {
                ...state,
                allMedicalServices: action.type === GET_ALL_MEDICAL_SERVICES_RESPONSE ? action.response : state.allMedicalServices,
                getAllMedicalServicesState: {
                    loading: action.type === GET_ALL_MEDICAL_SERVICES_REQUEST,
                    success: action.type === GET_ALL_MEDICAL_SERVICES_RESPONSE,
                    error: action.type === GET_ALL_MEDICAL_SERVICES_RESPONSE_ERROR && action.error,
                },
            };
        case APPROVE_ATTENTION_REQUEST:
        case APPROVE_ATTENTION_RESPONSE:
        case APPROVE_ATTENTION_RESPONSE_ERROR:
            return {
                ...state,
                attention: action.type === APPROVE_ATTENTION_RESPONSE ? action.response : state.attention,
                flagAmount: action.type === APPROVE_ATTENTION_RESPONSE ? action.response.flagAmount : state.flagAmount,
                approveAttentionState: {
                    loading: action.type === APPROVE_ATTENTION_REQUEST,
                    success: action.type === APPROVE_ATTENTION_RESPONSE,
                    error: action.type === APPROVE_ATTENTION_RESPONSE_ERROR && action.error,
                    message: action.type === APPROVE_ATTENTION_RESPONSE_ERROR && action.error ? action.error.message : '',
                },
            };
        case CREATE_ATTENTION_REQUEST:
        case CREATE_ATTENTION_RESPONSE:
        case CREATE_ATTENTION_RESPONSE_ERROR:
            return {
                ...state,
                createAttentionState: {
                    loading: action.type === CREATE_ATTENTION_REQUEST,
                    success: action.type === CREATE_ATTENTION_RESPONSE,
                    error: action.type === CREATE_ATTENTION_RESPONSE_ERROR && action.error,
                },
            };
        case GET_ALL_ATTENTIONS_REQUEST:
        case GET_ALL_ATTENTIONS_RESPONSE:
        case GET_ALL_ATTENTIONS_RESPONSE_ERROR:
            return {
                ...state,
                allAttentions: action.type === GET_ALL_ATTENTIONS_RESPONSE ? action.response : state.allAttentions,
                getAllAttentionsState: {
                    loading: action.type === GET_ALL_ATTENTIONS_REQUEST,
                    success: action.type === GET_ALL_ATTENTIONS_RESPONSE,
                    error: action.type === GET_ALL_ATTENTIONS_RESPONSE_ERROR && action.error,
                },
            };
        case GET_ALL_ATTENTIONS_DOWNLOAD_REQUEST:
            console.log('Reducer: Handling GET_ALL_ATTENTIONS_DOWNLOAD_REQUEST');

            return {
                ...state,
                getAllAttentionsToDownloadState: {loading: true, success: false, error: false},
            };
        // case GET_ALL_ATTENTIONS_DOWNLOAD_REQUEST:
        case GET_ALL_ATTENTIONS_DOWNLOAD_RESPONSE:
            console.log('Reducer: Handling GET_ALL_ATTENTIONS_DOWNLOAD_RESPONSE');
                return {
                    ...state,
                    attentionsToDownload: action.type === GET_ALL_ATTENTIONS_DOWNLOAD_RESPONSE ? action.response : state.attentionsToDownload,
                    getAllAttentionsToDownloadState: {loading: false, success: true, error: false},
        };
        case CLEAR_DELETE_ATTENTION_STATE:
            return {
                ...state,
                deletedAttentionState: initialState.deletedAttentionState,
            };
        case DELETE_ATTENTION_RESPONSE:
            return {
                ...state,
                deletedAttentionState: {
                    loading: false,
                    success: true,
                    error: false,
                },
            };
        case DELETE_ATTENTION_RESPONSE_ERROR:
            return {
                ...state,
                deletedAttentionState: {
                    loading: false,
                    success: false,
                    error: true,
                },
            };
        case SELECT_SELF:
        case SELECT_SELF_RESPONSE:
        case SELECT_SELF_RESPONSE_ERROR:
            return {
                ...state,
                setSelfState: {
                    loading: action.type === SELECT_SELF,
                    success: action.type === SELECT_SELF_RESPONSE,
                    error: action.type === SELECT_SELF_RESPONSE_ERROR && action.error,
                    featureFlag: action.type === SELECT_SELF_RESPONSE && action.response.featureFlag,
                },
            };
        case CLEAN_SELECT_SELF:
            return {
                ...state,
                setSelfState: initialState.setSelfState,
            };
        case CLEAN_AFFILIATES:
            return {
                ...state,
                affiliates: [],
            };
        case CLEAN_USERS:
            return {
                ...state,
                users: [],
            };
        case CLEAN_ATTENTION:
            return {
                ...state,
                attention: undefined,
            };
        case SET_AFFILIATE_SELECTED:
            return {
                ...state,
                affiliateSelected: action.affiliate,
            };
        case SET_ATTENTION_FOR_CREATE:
            return {
                ...state,
                attentionForCreate: action.attention,
            };
        case CLEAN_ATTENTION_FOR_CREATE:
            return {
                ...state,
                attentionForCreate: initialState.attentionForCreate,
            };
        case SET_ATTENTIONS_SELECTED:
            return {
                ...state,
                attentionsSelected: action.attentionsSelected,
                allMedicalServices: {
                    ...state.allMedicalServices,
                    results: state.allMedicalServices.results.map((x) => {
                        x.checked = action.attentionsSelected.some((att) => att.medicalServiceId === x.medicalServiceId);
                        return x;
                    })},
            };
        case CLEAN_ATTENTIONS_SELECTED:
            return {
                ...state,
                attentionsSelected: initialState.attentionsSelected,
            };
        case SELECT_PLAN:
            return {
                ...state,
                planSelected: action.plan,
            };
        case CLEAN_GET_AFFILIATES_STATE:
            return {
                ...state,
                getAffiliatesState: initialState.getAffiliatesState,
            };
        case BULK_INSERT:
        case BULK_INSERT_RESPONSE:
        case BULK_INSERT_RESPONSE_ERROR:
            return {
                ...state,
                bulkInsertResponse: action.type === BULK_INSERT_RESPONSE ? action.response : state.bulkInsertResponse,
                bulkInsertState: {
                    loading: action.type === BULK_INSERT,
                    success: action.type === BULK_INSERT_RESPONSE,
                    error: action.type === BULK_INSERT_RESPONSE_ERROR && action.error,
                },
            };
        case CLEAN_BULK_INSERT:
            return {
                ...state,
                bulkInsertResponse: initialState.bulkInsertResponse,
                bulkInsertState: initialState.bulkInsertState,
            };
        case REHYDRATE:
            const incoming = action.payload;
            if (incoming) {
                return {
                    ...initialState,
                };
            }
            return state;
        case GET_AMOUNT_LIST_REQUEST:
        case GET_AMOUNT_LIST_RESPONSE:
        case GET_AMOUNT_LIST_RESPONSE_ERROR:
            return {
                ...state,
                amountList: action.type === GET_AMOUNT_LIST_RESPONSE ? action.response.amounts : state.amountList,
                getAmountListState: {
                    loading: action.type === GET_AMOUNT_LIST_REQUEST,
                    success: action.type === GET_AMOUNT_LIST_RESPONSE,
                    error: action.type === GET_AMOUNT_LIST_RESPONSE_ERROR && action.error,
                },
            };

        case GET_ALL_AMOUNTS_DOWNLOAD_RESPONSE:
            return {
                ...state,
                amountListToDownload: action.response.amounts,
                getAllAttentionsToDownloadState: {loading: false, success: true, error: false},
            };
        case GET_ALL_ATTENTIONS_RESPONSE_ERROR:
            return {
                ...state,
                getAllAttentionsToDownloadState: { loading: false, success: false, error: true },
            };

        case CLEAN_AMOUNT_LIST_STATE:
            return {
                ...state,
                getAmountListState: {
                    loading: false,
                    success: false,
                    error: false,
                },
        };
        case SET_BRANCH_AND_PROVIDER:
            return {
                ...state,
                branchAndProviderForAttention: {provider: action.provider, branch: action.branch},
            };
        default:
            return state;
    }
};

export default homeReducer;
